export default __webpack_public_path__ + "static/media/books2-afterB-480w.bd013021.webp";